<template lang="html">
    <div class="breakout grid grid-cols-1 gap-700">
        <div class="grid grid-cols-1 gap-200">
            <MainHeading>{{ $t("home.title") }}</MainHeading>
            <MainSubheading>{{ $t("home.subtitle") }}</MainSubheading>
        </div>

        <div class="inner-wrapper">
            <TextBlock v-html="$t('home.introMain')" />
        </div>
    </div>
</template>

<script>
import MainHeading from "../typography/MainHeading";
import MainSubheading from "../typography/MainSubheading";
import TextBlock from "../typography/TextBlock";

const { messages } = require("../../i18n/home");

export default {
    name: "TitleBlock",
    i18n: { messages },
    components: {
        MainHeading,
        MainSubheading,
        TextBlock,
    },
};
</script>
